module.exports = __webpack_public_path__ + "static/media/michaelHeimert.4d424d47.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/michaelHeimert.jpg
// module id = 1580
// module chunks = 1